<template>
  <div class="place">
    <HeaderComponents></HeaderComponents>
    <div class="content">
      <div class="step">
        <Steps :current="step - 1">
          <Step title="服务形式和商品信息"></Step>
          <Step title="客户及物流信息"></Step>
          <Step title="完成"></Step>
        </Steps>
      </div>
      <!--  填写商品信息等    -->
      <Form v-if="step === 1" :label-width="90" label-position="left">
        <div class="category">
          <div class="title">服务类目</div>
          <div class="category-list">
            <div class="category-item point" :class="{active:item.id === formItem.class_id}"
              @click="categoryChange(item,index)" v-for="(item,index) in list" :key="index">
              <Avatar :src="item.img" icon="ios-person" size="large" />
              <div class="name">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <div class="mode">
          <div class="title">服务类型</div>
          <div class="mode-view">
            <tabNav :type="' '" :value='formItem.type_id' v-if="formItem.type_id" @change='changeType'
              :list="serviceList" v-model="formItem.type_id"></tabNav>
          </div>

        </div>
        <div class="mode">
          <div class="title">下单模式</div>
          <div class="mode-view">
            <tabNav :list="modeList" v-model="formItem.order_type"></tabNav>
          </div>
        </div>
        <div class="mode">
          <div class="title flex align-center">
            <div class="">
              商品信息
            </div>
            <div @click="historyTableVisible=true"
              class="point margin-left-30 line-theme text-theme radius-4 padding-lr-10">
              商品模板
            </div>

          </div>
          <Form class="form" :rules="ruleValidate">
            <FormItem label="商品图片:" prop="product_img">
              <Upload :max='5' :more.sync=img_more :imgList.sync="formItem.product_img"></Upload>
              <div class="tips">上传清晰图片，师傅更快接单，最多可上传5张图片</div>
            </FormItem>
            <FormItem label="商品类别:" prop="product_first_class_id">
              <Select style="width: 200px" id="class_one" v-model="formItem.product_first_class_id"
                @on-change="selectChange">
                <Option :value="item.id" v-for="(item,index) in allClass" :key='index'>{{item.name}}</Option>
              </Select>
              <Select style="width: 200px;margin-left: 15px" @on-change="selectChangeTwo"
                v-model="formItem.product_class_id">
                <Option :value="item.id" v-for="(item,index) in classTwo" :key='index'>{{item.name}}</Option>
              </Select>
              <InputNumber :min="1" :max='999' style="width: 100px;margin-left: 15px" controls-outside
                v-model="formItem.number" @input="numberChange($event)"></InputNumber>
              <div class="unit"></div>
              <div class="price" v-if="formItem.order_type==2">(参考价格：{{recommend_price}})</div>
            </FormItem>
            <FormItem label="保养类型:" v-if="formItem.type_id==5">
              <Select style="width: 200px" @on-change="selectMaintain" v-model="formItem.maintain_id">
                <Option :value="item.id" v-for="(item,index) in maintainList">{{item.value}}</Option>
              </Select>
            </FormItem>
            <FormItem label="安装要求:" v-if="formItem.type_id==1||formItem.type_id==8">
              <RadioGroup v-model="formItem.install_id">
                <Radio label="0">不需要拆旧</Radio>
                <Radio label="1" style="margin-left: 20px">需要拆旧</Radio>
              </RadioGroup>
              <div class="unit"></div>
            </FormItem>
            <FormItem label="拆卸要求:" v-if="formItem.type_id==18">
              <RadioGroup v-model="formItem.is_remove">
                <Radio label="2">不需要拆卸</Radio>
                <Radio label="1" style="margin-left: 20px">需要拆卸</Radio>
              </RadioGroup>
              <div class="unit"></div>
            </FormItem>
            <FormItem label="附属商品:"
              v-if="formItem.type_id==1||formItem.type_id==6||formItem.type_id==7||formItem.type_id==8||formItem.type_id==18">
              <Select style="width: 200px" @on-change="selectAccessory" v-model="formItem.accessory_id">
                <Option :value="item.id" v-for="(item,index) in accessoryGoods">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="商品型号:" v-if="formItem.type_id!=5&&formItem.type_id!=12">
              <Input class="input" placeholder="请输入商品型号" maxlength="50" v-model="formItem.product_model"></Input>
            </FormItem>
            <FormItem label="商品尺寸:" v-if="formItem.type_id==1||formItem.type_id==8">
              <Input class="input" placeholder="请输入商品尺寸" maxlength="50" v-model="formItem.product_size"></Input>
            </FormItem>
            <FormItem label="安装图:" v-if="formItem.type_id!=5&&formItem.type_id!=12">
              <div style="margin-top: 10px">
                <Upload :max='5' :more.sync=img_more :imgList.sync="formItem.install_img"></Upload>
                <div class="tips">上传安装图片，可提高师傅安装效率，降低售后成本</div>
              </div>
            </FormItem>
            <FormItem label="环境图:" v-if="formItem.type_id!=5&&formItem.type_id!=12">
              <RadioGroup v-model="formItem.install_upload">
                <Radio label="1">不上传安装环境图</Radio>
                <Radio label="2" style="margin-left: 20px">上传安装环境图</Radio>
              </RadioGroup>
              <div style="margin-top: 10px" v-if="formItem.install_upload == '2'">
                <Upload :max='5' :more.sync=img_more :imgList.sync="formItem.environment_img"></Upload>
                <div class="tips">上传环境图片，可提高师傅安装效率，降低售后成本</div>
              </div>
            </FormItem>
            <FormItem :label="formItem.type_id==12?'故障描述:':'特殊要求:'" v-if="formItem.type_id!=5" prop='special'>
              <Input class="input" maxlength="200" :rows="5" type="textarea" v-model="formItem.special"
                :placeholder="formItem.type_id==12?'请输入故障描述':'请填写尺寸、体积、重量等特殊要求，有利于得到师傅更准确的报价'"></Input>
            </FormItem>
            <FormItem label="保养要求:" v-if="formItem.type_id==5" prop='special'>
              <Input class="input" maxlength="200" :rows="5" type="textarea" v-model="formItem.special"
                placeholder="请输入保养要求"></Input>
            </FormItem>
            <div class="total" v-if="formItem.order_type==2">
              费用小计：<span style="color: red">￥{{formItem.total_price}}</span>（基础安装费：{{formItem.total_price}}）
            </div>
          </Form>
        </div>
      </Form>
      <!--  填写其他信息    -->
      <Form v-if="step === 2" :label-width="90" label-position="left" :rules="ruleValidate2">
        <div class="mode">
          <div class="title">客户信息</div>
          <div class="form">
            <FormItem label="智能识别:">
              <Input class="input" :rows="5" type="textarea" v-model="allAddress"
                placeholder="粘贴整段地址，自动识别姓名、手机号和地址自动填充"></Input>
              <span style="margin-left: 30px;cursor: pointer"
                class="bg-theme padding-lr-sm padding-tb-6 text-white radius-4" @click="distinguish">
                立即识别</span>
            </FormItem>
            <FormItem label="真实姓名:" prop='name'>
              <Input class="input" placeholder="请输入真实姓名" maxlength="6" v-model="formTwo.name"></Input>
            </FormItem>
            <FormItem label="手机号:" prop='phone'>
              <Input class="input" maxlength="11" type="number" placeholder="手机号" v-model="formTwo.phone"></Input>
            </FormItem>
            <FormItem label="所在地区:" prop='city'>
              <Cascader class="input" :data="areaList" v-model="city" placeholder="请选择位置" @on-change="cityChange">
              </Cascader>
              <!-- <div class="line-ddd padding-tb-4 padding-lr-6 wn40" :class="formTwo.city?'text-333':'text-ddd'"
                @click="chooseCompanyAddress">
                {{formTwo.city||'请选择位置'}}
              </div> -->
              <!--  <Input class="input"  placeholder="请选择位置"
                v-model="formTwo.city"></Input> -->
            </FormItem>
            <FormItem label="详细地址:" prop='address'>
              <Input class="input" :rows="3" type="textarea" v-model="formTwo.address" placeholder="街道/门牌信息"></Input>
            </FormItem>
            <FormItem label="是否有电梯:">
              <RadioGroup v-model="formTwo.is_elevator">
                <Radio label="1">有电梯</Radio>
                <Radio label="0" style="margin-left: 20px">无电梯</Radio>
              </RadioGroup>
              <span style="margin-left: 30px">客户所在楼层：</span>
              <InputNumber :max="100" :min="1" style="margin:0 10px" v-model="formTwo.floor">
              </InputNumber>
              层
            </FormItem>
          </div>
        </div>
        <div class="mode">
          <div class="title">物流信息</div>
          <Form class="form" :label-width="90" label-position="left">
            <FormItem label="是否已到达:">
              <RadioGroup v-model="fromThree.is_arrive">
                <Radio label="1">已到达</Radio>
                <Radio label="2" style="margin-left: 20px">未到货</Radio>
              </RadioGroup>

              <span style="margin-left: 30px" v-if="fromThree.is_arrive==2">预计到货日期：</span>
              <el-date-picker v-if="fromThree.is_arrive==2" v-model="fromThree.arrive_time" type="date"
                :picker-options="pickerOptions" placeholder="请选择" class="width-200" value-format="yyyy-MM-dd">
              </el-date-picker>
              <!-- <DatePicker type="datetime" :picker-options="pickerOptions" v-model="fromThree.arrive_time"
                placeholder="请选择日期" style="width: 200px">
              </DatePicker> -->
            </FormItem>
            <FormItem label="代付运费:">
              <RadioGroup v-model="fromThree.is_freight">
                <Radio label="1">不需要</Radio>
                <Radio label="2" style="margin-left: 20px">需要</Radio>
              </RadioGroup>
              <span v-if="fromThree.is_freight==2">
                <span style="margin-left: 42px" v-if="fromThree.is_freight==2">代付金额：</span>
                <InputNumber :max="10000" v-if="fromThree.is_freight==2" v-model="fromThree.freight" :min="1"
                  style="margin:0 10px"></InputNumber>
                元
              </span>

            </FormItem>
            <FormItem label="提货姓名:">
              <Input class="input" placeholder="请输入提货姓名" maxlength='6' v-model="fromThree.name"></Input>
            </FormItem>
            <FormItem label="提货电话:">
              <Input class="input" placeholder="请输入提货电话" :value="fromThree.phone"
                oninput="value=value.replace(/[^\d]/g,'').slice(0,11)" maxlength="11" type="number"
                v-model="fromThree.phone"></Input>
            </FormItem>
            <FormItem label="包裹件数:">
              <InputNumber :max="1000" :min="1" style="margin:0 10px" v-model="fromThree.package_number">
              </InputNumber>
              件
              <span class="tips" style="margin-left: 30px">货物影响师傅报价，获得报价后无法修改，请准确填写</span>
            </FormItem>
            <FormItem label="提货地址:">
              <Input class="input" placeholder="请输入提货地址" v-model="fromThree.address"></Input>
            </FormItem>
            <FormItem label="物流单号:">
              <Input class="input" placeholder="请输入物流单号" v-model="fromThree.logistics_number"></Input>
            </FormItem>
            <FormItem label="物流公司:">
              <Select style="width: 500px" v-model="fromThree.company">
                <Option :value="item.id" v-for="(item,i) in companyData">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="包装要求:">
              <Select style="width: 500px" v-model="fromThree.package_require">
                <Option :value="item.id" v-for="(item,i) in reqList">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="保价要求:">
              <Select style="width: 500px" v-model="fromThree.insurance">
                <Option :value="item.id" v-for="(item,i) in quoteList">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="保价金额:" v-if="fromThree.insurance==1">
              <InputNumber :max="10000" v-model="fromThree.valuation" :min="1" style="margin:0 10px">
              </InputNumber>
              元
            </FormItem>
            <FormItem label="送货方式:">
              <Select style="width: 500px" v-model="fromThree.shipping_method">
                <Option :value="item.id" v-for="(item,i) in extragoodsList">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="代付方式:">
              <Select style="width: 500px" v-model="fromThree.pay_method">
                <Option :value="item.id" v-for="(item,i) in paymentList">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Form>
        </div>
        <div class="mode">
          <div class="title">下单方联系人</div>
          <div class="form">
            <FormItem label="联系人:" prop='order_contact'>
              <Input class="input" placeholder="请输入订单联系人" maxlength="6" v-model="fromThree.order_contact"></Input>
            </FormItem>
            <FormItem label="联系电话:">
              <Input class="input" type="number" maxlength="11" placeholder="请输入联系电话"
                v-model="fromThree.order_phone"></Input>
            </FormItem>
            <FormItem label="期望时间:">
              <el-date-picker v-model="fromThree.hope_complete" type="date" :picker-options="pickerOptions"
                placeholder="请选择" class="width-400" value-format="yyyy-MM-dd">
              </el-date-picker>
              <!-- <DatePicker type="datetime" placeholder="请选择日期" style="width: 400px" v-model="fromThree.hope_complete">
              </DatePicker> -->
              <span style="margin-left: 10px;">日前完成服务</span>
            </FormItem>
          </div>
        </div>
        <!-- <div class="mode">
          <div class="title">艺棒小匠为您提供</div>
          <div class="form">
            <FormItem label="是否核销:">
              <RadioGroup v-model="fromThree.third_name">
                <Radio label="0">否</Radio>
                <Radio :label="item.id" style="margin-left: 20px" v-for="(item,i) in thirdData">
                  {{item.name}}
                </Radio>
              </RadioGroup>
            </FormItem>
          
          </div>
        </div> -->
      </Form>
      <el-result icon="success" title="下单成功" subTitle="系统已通过智能推单，将您的订单推送给所在区域附近的师傅" v-if="step === 3">
        <template slot="extra">
          <div class="">订单编号：{{order_munber}}
            <Icon type="ios-browsers" @click="copyText(order_munber)" />
          </div>
          <div class="handle" style="margin-top: 30px">
            <Button type="default" @click="$router.push({name:'order_list'})">进入订单列表</Button>
            <Button type="primary" style="margin-left: 20px" @click="placeOrder()">继续下单</Button>
          </div>
        </template>
      </el-result>
      <div style="height: 74px"></div>
    </div>
    <div class="footer" v-if="step !== 3">
      <!--  填写商品信息等    -->
      <div class="place" v-if="step === 1">
        <div style="margin-right: 20px">共有{{formItem.number}}个商品，
          <span v-if="formItem.order_type==2">
            应付费用：<span style="color: red">￥{{formItem.total_price}}</span>
          </span>
        </div>
        <Button type="primary" @click="nextStep()">下一步</Button>
      </div>
      <!--  填写其他信息    -->
      <div class="other" v-if="step === 2">
        <Button @click="step --">返回上一步</Button>
        <Button type="primary" @click="submit()">提交订单</Button>
      </div>
    </div>
    <!-- 商品模板弹框 -->
    <div class="mask" @click="historyTableVisible=false" v-if="historyTableVisible"></div>
    <div class="box-content-map bg-white radius-6 ovflowHidden  " v-if="historyTableVisible">
      <div class="     ">
        <div class="flex align-center justify-between padding map-set ">
          <div class="">
            选择历史商品
          </div>
          <span class="padding-lr-sm padding-tb-10 radius-4 bg-f8 text-333 point"
            @click="historyTableVisible=false">取消</span>
        </div>
        <div class="padding-lr-40 ovflowScrolly" style="height: 70vh;">
          <div class="flex align-center justify-between solid-bottom padding-tb-20 point"
            @click="selectHistoryItem(item,index)" v-for="(item,index) in historyGoodsList" :key='index'>
            <div class="block-100 radius-6 overHidden">
              <img :src="item.product_img[0]" alt="加载中" class="block-100">
            </div>
            <div class="wn78">
              <p class="">{{item.product_class}}</p>
              <p class="padding-top-15 text-999">
                <span>价格：{{item.product_price}}</span>
                <span class="margin-left-40">数量：{{item.number}}</span>
              </p>
              <p class="padding-top-15 text-999 ewrp">特殊要求：{{item.special}}</p>
            </div>

          </div>
          <div class="padding text-center  wn100" v-if="historyGoodsList.length==0">
            该类目下暂未添加历史商品
          </div>
        </div>
      </div>
    </div>
    <!-- 城市选择 -->
    <!-- 定位城市位置弹框 -->
    <div class="mask" @click="mapTableVisible=false" v-if="mapTableVisible"></div>
    <div class="box-content-map bg-white radius-6 ovflowHidden  " v-if="mapTableVisible">
      <div class="     ">
        <div id="mapId" class="relative" style="width:100%;height:300px;"> </div>
        <div class="flex align-center justify-between padding map-set ">
          <span class="padding-lr-sm padding-tb-10 radius-4 bg-f8 text-333 point"
            @click="mapTableVisible=false">取消</span>
          <span class="padding-lr-sm padding-tb-10 radius-4 bg-theme text-white point" @click="confirmAddress">确定</span>
        </div>
        <div class=" padding-15 margin-lr flex align-center justify-between  margin-tb line-eee radius-32 wn78">
          <div class="flex align-center">
            <i class="el-icon-search"></i>
            <input type="text" v-model="address" placeholder="请输入城市名" id='tipinput' @keypress="search">
          </div>
          <span @click="search" class="text-right point">搜索</span>
        </div>
        <!-- 搜索结果列表 -->
        <div class="padding-lr-40 ovflowScrolly" style="height: 200px;">
          <div class="flex align-center justify-between solid-bottom padding-tb-20 point"
            @click="selectSearchList(item,index)" v-for="(item,index) in poiArr" :key='index'>
            <div class="wn78">
              <p class="">{{item.name}}</p>
              <p class="padding-top-15 text-999">{{item.address}}</p>
            </div>
            <div class="">
              <i class="el-icon-check text-theme fs28" v-if="searchIndex==index"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 城市选择 -->
  </div>
</template>

<script>
  import HeaderComponents from '../../components/header';
  import tabNav from '../../components/tabNav';
  import Upload from '../../components/upload';
  import MapLoader from "@/assets/js/loadMap";
  // 智能解析地址
  import parse from '@/libs/parsingAddress.js';
  import areaList from '@/libs/areadata.js';
  export default {
    name: 'place',
    components: {
      HeaderComponents,
      Upload,
      tabNav
    },
    data() {
      return {
        recommend_price: 0,
        step: 1,
        allAddress: '', //智能识别地址信息
        mapTableVisible: false, //位置弹框
        historyTableVisible: false, //历史商品弹框
        historyGoodsList: [], //历史商品列表
        historyIndex: '', //选择的索引
        maintainList: [], //保养类型
        searchIndex: 0, //选择地址
        address: '', //搜索的地区
        poiArr: [], //搜索出来的数组
        chooseAddress: '', //选择的地址定位
        longitude: '', //选择的位置的经纬度
        latitude: '',
        order_munber: "",
        img_more: true,
        formItem: {
          product_img: [],
          environment_img: [],
          class_id: 0,
          product_first_class_id: 0,
          number: 1,
          product_class_id: 0,
          total_price: 0,
          product_model: '',
          special: '',
          arrive: '2',
          behalf: '2',
          is_remove: '2',
          elevator: '2',
          install_upload: '1', //需要是字符串格式的数据才能默认选中
          order_type: 1,
          maintain_id: '',
          maintain: '',
          type_id: 1,
        },
        ruleValidate: {
          product_img: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          product_first_class_id: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          special: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }]
        },
        ruleValidate2: {
          name: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          city: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],
          order_contact: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }]
        },
        ruleValidate3: {
          name: [{
            required: true,
            message: ' ',
            trigger: 'blur'
          }],

        },
        accessoryGoods: [], //附属商品
        modeList: [], //下单类型
        city: [],
        formTwo: {
          name: "",
          phone: "",
          address: "",
          floor: '',
          is_elevator: '',
          number: 0,
          price: 0,
          city: '',
          latitude: '',
          longitude: '',
        },
        pickerOptions: {
          disabledDate(time) {
            // console.log(time.getTime(),Date.now(),'时间'); 
            // 减去一天的时间
            return time.getTime() < Date.now() - 86400000;
          },
        },
        fromThree: {
          order_contact: "",
          order_phone: "",
          hope_complete: "",
          third_name: "0",
          is_logistics: 1,
          name: "",
          is_arrive: 0,
          phone: "",
          company: '',
          address: "",
          insurance: '', //保价要求
          package_require: '',
          package_number: '',
          valuation: "0", //保价金额
          is_freight: 1,
          freight: 0,
          shipping_method: 0,
          pay_method: 0,
          arrive_time: "",
          logistics_number: "",
        },
        classOne: [],
        classTwo: [],
        thirdData: [],
        companyData: [],
        serviceList: [],
        reqList: [], //包装要求
        quoteList: [{
          name: '不保价',
          id: '0'
        }, {
          name: '保价',
          id: '1'
        }], //保价要求
        extragoodsList: [], //送货方式
        paymentList: [], //代付方式
        list: [],
        allClass: [],
        areaList: areaList,
        order_id: 0, //修改订单进入
      }
    },
    created() {


      let vm = this
      console.log(this.$route.params, 'this.$route.params');
      vm.formItem.class_id = this.$route.params.id || ''
      vm.order_id = this.$route.params.order_id || 0 //修改订单进入

      vm.thirdData = []
      // this.$request('61177c8371904', {
      //   "scene": "5"
      // }).then(res => {
      //   res.data.data.forEach(function(item) {
      //     vm.thirdData.push({
      //       id: item.id,
      //       name: item.name,
      //     })
      //   })
      // })
      this.$request('61177c8371904', {
        "scene": "4"
      }).then(res => {
        vm.reqList = res.data.data
      })
      this.$request('61177c8371904', {
        "scene": "9"
      }).then(res => {
        vm.extragoodsList = res.data.data
      })
      this.$request('61177c8371904', {
        "scene": "8"
      }).then(res => {
        vm.paymentList = res.data.data
      })


      vm.companyData = []
      this.$request('61177c8371904', {
        "scene": "2"
      }).then(res => {
        res.data.data.forEach(function(item) {
          vm.companyData.push({
            id: item.id,
            name: item.name,
          })
        })
      })

      this.$request('611b5e915c69e', {}).then(res => {
        vm.list = []
        res.data.data.list.forEach(function(item) {
          // 服务类目
          vm.list.push({
            id: item.id,
            img: item.thumbnail,
            recommend_price: item.recommend_price || 0,
            value: item.name,
            show_service_type: item.show_service_type, //服务类型
            pay_type: item.pay_type, //下单模式
          })
        })
        vm.serviceList = []
        vm.modeList = []
        if (vm.formItem.class_id) {
          let idx = vm.list.findIndex(item => item.id == vm.formItem.class_id)

          vm.list[idx].show_service_type.forEach(function(item) {
            vm.serviceList.push({
              value: item.id,
              label: item.name,
              is_elevator: item.is_elevator,
              is_logistics: item.is_logistics,
            })
            vm.formItem.type_id = vm.serviceList[0].value
          })
          vm.list[idx].pay_type.forEach(function(item) {
            vm.modeList.push({
              value: item.id,
              label: item.name,
            })
          })
          vm.getGoodsClass(vm.formItem.class_id)
          vm.getHistoryInfo()
        } else {
          vm.formItem.class_id = vm.list[0].id
          vm.getHistoryInfo()
          vm.getGoodsClass(vm.formItem.class_id)
          vm.list[0].show_service_type.forEach(function(item) {
            vm.serviceList.push({
              value: item.id,
              label: item.name,
              is_elevator: item.is_elevator,
              is_logistics: item.is_logistics
            })
            vm.formItem.type_id = vm.serviceList[0].value
          })
          vm.list[0].pay_type.forEach(function(item) {
            vm.modeList.push({
              value: item.id,
              label: item.name,
            })
          })
        }
      })
      this.getMationList()
      if (vm.order_id > 0) {
        setTimeout(()=>{
          vm.getOrderDetail()
        },300)
      } else {
        console.log(global.userInfo, 'userInfo');
        let _userInfo = global.userInfo
        if (_userInfo) {
          this.fromThree.order_contact = _userInfo.nickname
          this.fromThree.order_phone = _userInfo.phone
        }
      }
    },
    methods: {
      // 获取订单详情  修改订单进入
      getOrderDetail() {
        let vm = this
        this.$request('6120ad9af2b9b', {
          order_id: vm.order_id
        }).then(res => {
          let ress = res.data.data
          this.formItem.class_id = ress.class_id
          this.formItem.type_id = ress.type_id
          this.formItem.order_type = ress.order_type
          // 商品信息
          this.formItem.product_img = ress.product.product_img
         this.formItem.product_class_id = ress.product.product_class_id
         this.formItem.product_first_class_id = ress.product.product_first_class_id
         vm.getGoodsClass(ress.class_id)
          this.formItem.special = ress.product.special
          this.recommend_price = ress.product.reference
          this.formItem.maintain_id = ress.product.product_maintain_id
          this.formItem.install_id = ress.product.install_id+'' //安装要求 0不需要 1需要
          this.formItem.is_remove = ress.product.is_remove //拆卸要求
          // 附属商品
          this.formItem.accessory_id = ress.product.product_affiliated //
          this.formItem.product_model = ress.product.product_model //
          this.formItem.product_size = ress.product.product_size //
          this.formItem.install_img = ress.product.install_img //安装图
          this.formItem.install_upload = ress.product.environment_img.length > 0 ? '2' : '1' // 1不上传 2上传环境图
          console.log('install_upload', this.formItem.install_upload);
          this.formItem.environment_img = ress.product.environment_img //环境图
          this.formItem.number = ress.product.num //
          vm.formItem.total_price = vm.recommend_price * vm.formItem.number //总计
          // 第二步 地址信息
          vm.formTwo.name = ress.address.name
          vm.formTwo.phone = ress.address.phone
          // vm.city = ress.address.pro_city_dist
          vm.formTwo.city=ress.address.pro_city_dist
          vm.formTwo.address = ress.address.detailed_address
           this.getGeo(ress.address.pro_city_dist, ress.address.detailed_address);
          vm.formTwo.floor = ress.address.floor=='无电梯'?'': ress.address.floor
          vm.formTwo.is_elevator = ress.address.floor == '无电梯' ? '0' : '1'
          // 第三步 物流信息
          vm.fromThree.is_arrive = ress.logistics.arrive=='已到货'?'1':'2' //是否到达1已到 2未到
          vm.fromThree.arrive_time = ress.logistics.arrive_time+'',//
          vm.fromThree.is_freight = ress.logistics.freight?'2':'1' //代付运费 1不需要 2需要
          vm.fromThree.freight = Number(ress.logistics.freight)  //代付金额
          vm.fromThree.name = ress.logistics.name // 提货姓名
          vm.fromThree.phone = ress.logistics.phone //提货电话
          vm.fromThree.package_number = ress.logistics.package_number //包裹数量
          vm.fromThree.address = ress.logistics.address //提货地址
          vm.fromThree.logistics_number = ress.logistics.logistics_number //物流单号
          
          let idx_c = this.companyData.findIndex(item => item.name == ress.logistics.company)
          vm.fromThree.company = this.companyData[idx_c].id //物流公司

          let idx_p = this.reqList.findIndex(item => item.name == ress.logistics.package_require)
          vm.fromThree.package_require = this.reqList[idx_p].id //包装要求
          vm.fromThree.insurance = ress.logistics.valuation>0?'1':'0' //保价要求
          vm.fromThree.valuation = ress.logistics.valuation //保价金额
          let idx_s = this.extragoodsList.findIndex(item => item.name == ress.logistics.shipping_method)
          
          vm.fromThree.shipping_method = this.extragoodsList[idx_s].id //送货方式
          
          let idx_pp = this.paymentList.findIndex(item => item.name == ress.logistics.pay_method)
         
          vm.fromThree.pay_method = this.paymentList[idx_pp].id //代付方式
          let idx_t = this.thirdData.findIndex(item => item.name == ress.third)
          
          vm.fromThree.third_name = this.thirdData[idx_t].id //三方核销
          // 其他信息
          this.fromThree.order_contact = ress.other.contact_name
          this.fromThree.order_phone = ress.other.contact_phone
          this.fromThree.hope_complete = ress.other.hope_complete

        })
      },
      //复制
      copyText(val) {
        const textarea = document.createElement("textarea");
        textarea.value = val;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$message.success("已复制")

      },
      // 获取保养类型
      getMationList() {
        let vm = this
        this.$request('62cea0653cc84').then(res => {
          res.data.data.forEach(function(item) {
            vm.maintainList.push({
              id: item.id,
              value: item.maintain_name,
            })
          })
        })
      },
      // 获取历史商品
      getHistoryInfo() {
        this.$request('62c6572875a53', {
          product_id: this.formItem.class_id
        }).then(res => {
          this.historyGoodsList = res.data.data
        })
      },
      // 选择服务类目
      categoryChange(itm, index) {
        console.log(index, '============');
        let vm = this
        this.formItem.class_id = itm.id
        this.formItem.product_img = []
        this.formItem.environment_img = []
        this.formItem.install_img = []

        this.formItem.product_model = ''
        this.formItem.special = ''


        vm.getHistoryInfo()
        vm.serviceList = []
        vm.modeList = []
        vm.list[index].show_service_type.forEach(function(item) {
          vm.serviceList.push({
            value: item.id,
            label: item.name,
            is_elevator: item.is_elevator,
            is_logistics: item.is_logistics,
          })
        })
        vm.formItem.type_id = vm.serviceList[0].value
        vm.list[index].pay_type.forEach(function(item) {
          vm.modeList.push({
            value: item.id,
            label: item.name,
          })
        })
        vm.recommend_price = itm.recommend_price || 0
        vm.calculationTotal()
        vm.formItem.product_first_class_id = 0
        vm.getGoodsClass(itm.id)
      },
      // 获取附属商品
      getAccessoryList() {
        this.$request('6142cf1057b93', {
          product_first_class_id: this.formItem.product_first_class_id,
          class_id: this.formItem.class_id
        }).then(res => {
          this.accessoryGoods = res.data.data
        })
      },
      // 获取商品分类
      getGoodsClass() {
        let vm = this
        vm.allClass = []
        this.$request('6142ac6031e35', {
          class_id: this.formItem.class_id
        }).then(res => {
          vm.allClass = res.data.data
          if (vm.formItem.product_first_class_id) {
            let index = vm.allClass.findIndex(item => item.id == vm.formItem.product_first_class_id)
            vm.classTwo = res.data.data[index] && res.data.data[index].childens
          } else {
            vm.classTwo = res.data.data[0] && res.data.data[0].childens
          }
        })
      },
      // 选择历史商品
      selectHistoryItem(item) {
        this.formItem = {
          class_id: item.class_id, // 服务类目id
          order_type: item.order_type, // 订单类型
          type_id: item.type_id, // 服务类型id
          product_img: item.product_img, // 商品图片
          install_img: item.install_img || [], //安装图
          environment_img: item.environment_img || '', // 环境图片
          product_class_id: item.product_class_id, // 商品类型二级id
          product_first_class_id: item.product_first_class_id, //一级id
          number: item.number || '',
          install_id: item.install_id || '', //安装要求
          accessory_id: item.product_affiliated[0].affiliate_id,
          accessory: item.product_affiliated[0].affiliate || "",
          product_affiliated: item.product_affiliated, // this.form.extraGoods, // 附属商品
          product_model: item.product_model || '', // 商品型号
          is_remove: item.is_remove, // 拆卸要求 0-不用到这个,1-需要拆卸,2-不需要拆卸
          product_size: item.product_size || '', // 商品尺寸
          maintain: item.product_maintain || '', //保养要求
          maintain_id: item.product_maintain_id || '', //保养要求id
          special: item.special || '', // 特殊要求
          product_price: item.product_price,
        }
        this.calculationTotal()
        this.getGoodsClass(this.formItem.class_id)
        this.getMationList()
        this.getAccessoryList()
        this.historyTableVisible = false
      },
      changeType(data) {
        console.log(data, '选择的服务类型data');
        this.formItem.type_id = data
      },
      // 智能识别地址
      async distinguish() {
        if (!this.allAddress) {
          return this.$message.error('请输入内容')
        }

        if (this.allAddress) {
          // 张三18738978924江苏省扬州市广陵区XX小区X楼xxx室
          let info = parse(this.allAddress.trim());
          console.log(info, 'info');
          // this.phone = info.phone ? info.phone : info.mobile;
          this.formTwo.name = info.name;
          this.formTwo.phone = info.phone ? info.phone : info.mobile;
          let city = info.province + '-' + info.city + '-' + info.area;
          await this.getGeo(city, info.addr);
          this.formTwo.address = info.addr;
          this.formTwo.city = city
          this.fallAddress = '';
        }
      },
      /**获取地图定位 1*/
      getLocation() {
        let _that = this;
        MapLoader().then(aMap => {
          console.log(aMap, 'aMap');
          AMap.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000,
              // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
              buttonOffset: new AMap.Pixel(10, 20),
              //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
              zoomToAccuracy: true,
              //  定位按钮的排放位置,  RB表示右下
              buttonPosition: 'RB'
            })
            geolocation.getCityInfo((status, result) => {
              if (status == 'complete') {
                onComplete(result)
                console.log(result, 'result');
              } else {
                onError(result)
              }
            })

            function onComplete(data) {
              // data是具体的定位信息
              console.log(data.position, 'data.position=======');
              _that.longitude = data.center[0]
              _that.latitude = data.center[1]
              _that.address = data.city
              // _that.marker = [data.position.lng, data.position.lat]
            }

            function onError(data) {
              // 定位出错
            }
          })
        })
      },
      //创建一个map
      mapInit() {
        let that = this;
        let lng = that.longitude
        let lat = that.latitude
        MapLoader().then(aMap => {
          that.mapObj = new AMap.Map("mapId", {
            resizeEnable: true,
            zoom: 12, //初始地图级别
            center: [lng, lat], //初始中心点坐标
          });
          that.marker = new AMap.Marker({
            position: [lng, lat]
          })
          that.mapObj.add(that.marker);
          //地图加载完成，loading关闭
          that.mapObj.on("complete", function(res) {});
          //监听点击事件
          that.mapObj.on('click', function(e) {
            // console.log(e.lnglat.getLng() + ',' + e.lnglat.getLat());
            that.add(e.lnglat.getLng(), e.lnglat.getLat())
            that.aMapSearchNearBy([e.lnglat.getLng(), e.lnglat.getLat()])
          });
          // this.search(that.mapObj)
        });
      },
      search(mapObj) {
        let that = this;
        that.mapObj.remove(that.marker);
        var keywords = this.address;
        let placeSearch = new AMap.PlaceSearch({
          citylimit: false, // 是否强制在设置的城市内搜索，默认false
          type: "", // 兴趣点类别，用‘|’分隔，默认：'餐饮服务|商务住宅|生活服务'
          pageSize: 20, // 每页条数，默认10，范围1-50
          pageIndex: 1, // 页码
          extensions: "all", // 默认base，返回基本地址信息；all：返回详细信息
          autoFitView: true, // 是否自动调整地图视野到marker点都处于可见范围
          input: this.address, //输入框
        });
        let lng = this.longitude
        let lat = this.latitude
        placeSearch.search(
          keywords,
          function(status, result) {
            console.log(result, "result-----------");
            if (result && result.poiList && result.poiList.pois) {
              that.poiArr = result.poiList.pois
              that.chooseAddress = result.poiList.pois[0]
              that.searchIndex = 0
              let lat = result.poiList.pois[0].location.lat;
              let lng = result.poiList.pois[0].location.lng;
              // that.mapObj.setCenter([lng, lat]); //设置地图中心点
              if (that.marker) {
                that.marker.setMap(null);
                that.marker = null;
              }
              that.marker = new AMap.Marker({
                icon: new AMap.Icon({
                  image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                  size: new AMap.Size(22, 28), //图标所处区域大小
                  imageSize: new AMap.Size(22, 28) //图标大小
                }),
                position: [lng, lat],
                offset: new AMap.Pixel(-13, -30),
              })
              that.mapObj.add(that.marker);
              console.log("chooseAddress: ", that.chooseAddress);
            } else {
              that.poiArr = []
            }
          }
        )

      },
      // 在地图上加个点
      add(lng, lat) {
        let that = this
        if (that.marker) {
          that.marker.setMap(null);
          that.marker = null;
        }
        that.marker = new AMap.Marker({
          icon: new AMap.Icon({
            image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
            size: new AMap.Size(22, 28), //图标所处区域大小
            imageSize: new AMap.Size(22, 28) //图标大小
          }),
          position: [lng, lat],
          offset: new AMap.Pixel(-13, -30),
          imageSize: new AMap.Size(10, 10),
        });
        that.marker.setMap(that.mapObj);
      },
      // 查询周边信息
      aMapSearchNearBy(centerPoint, city) {
        let that = this
        AMap.service(["AMap.PlaceSearch"], function() {
          let placeSearch = new AMap.PlaceSearch({
            pageSize: 20, // 每页10条
            pageIndex: 1, // 获取第一页
            city: city // 指定城市名(如果你获取不到城市名称，这个参数也可以不传，注释掉)
          });
          // 第一个参数是关键字，这里传入的空表示不需要根据关键字过滤
          // 第二个参数是经纬度，数组类型
          // 第三个参数是半径，周边的范围
          // 第四个参数为回调函数
          placeSearch.searchNearBy('', centerPoint, 200, function(status, result) {
            if (result.info === 'OK') {
              console.log(result);
              // var locationList = result.poiList.pois;
              that.poiArr = result.poiList.pois;
              that.address = result.poiList.pois[0].name
              that.selectSearchList(result.poiList.pois[0], 0)
            } else {
              console.log('获取位置信息失败!');
            }
          });
        });
      },
      confirmAddress() {
        console.log(this.chooseAddress, 'chooseAddress');
        this.longitude = Number(this.chooseAddress.location.lng);
        this.latitude = Number(this.chooseAddress.location.lat);
        if (!this.chooseAddress.adname) {
          this.userInfo.workCity = this.chooseAddress.address + ' ' + this
            .chooseAddress.name || ''
        } else {
          this.userInfo.workCity = this.chooseAddress.cityname + ' ' + this.chooseAddress.adname + ' ' + this
            .chooseAddress.name
        }
        let lat = this.longitude + ',' + this.latitude;
        this.ajax('post', '/v1/5f60a4e907483', {
          user_id: global.userInfo && global.userInfo.id || '',
          cid: '',
          lat: lat
        }, res => {
          if (res.code == 1) {
            this.area_id = res.data.id
          }
        }, err => {
          this.$message.error(err);
        })

        this.mapTableVisible = false
      },
      selectSearchList(item, index) {
        console.log("item: ", item);
        this.address = item.name
        this.searchIndex = index
        this.chooseAddress = item
        let lat = item.location.lat;
        let lng = item.location.lng;
        this.add(lng, lat)
        this.mapObj.panTo([lng, lat]);
      },
      // 选择公司地址
      chooseCompanyAddress() {
        this.mapTableVisible = true
        this.mapInit()
      },
      nextStep() {
        let vm = this
        if (!this.formItem.class_id) {
          return this.$message.error('请选择服务类目')
        }
        if (!this.formItem.type_id) {
          return this.$message.error('请选择服务类型')
        }
        if (this.formItem.product_img.length == 0) {
          return this.$message.error('请上传商品图片')
        }
        if (!this.formItem.product_class_id || !this.formItem.product_first_class_id) {
          return this.$message.error('请选择商品类别')
        }

        if (!this.formItem.special) {
          let message = '请输入特殊要求'
          if (this.formItem.type_id == 12) {
            message = '请输入故障描述'
          } else if (this.formItem.type_id == 5) {
            message = '请输入保养要求'
          } else {
            message = '请输入特殊要求'
          }
          return this.$message.error(message)
        }
        // 添加商品
        let data = {
          class_id: this.formItem.class_id, // 服务类目id
          order_type: this.formItem.order_type, // 订单类型
          type_id: this.formItem.type_id, // 服务类型id
          product_img: this.formItem.product_img, // 商品图片
          install_img: this.formItem.install_img || [], //安装图
          environment_img: this.formItem.environment_img || '', // 环境图片
          product_class_id: this.formItem.product_class_id, // 商品类型二级id
          product_first_class_id: this.formItem.product_first_class_id, //一级id
          number: this.formItem.number || '',
          install_id: this.formItem.install_id || '', //安装要求
          product_affiliated: [{
            number: 1,
            affiliate: this.formItem.accessory || '',
            accessory_id: this.formItem.affiliate_id || ''
          }], // this.form.extraGoods, // 附属商品
          product_model: this.formItem.product_model || '', // 商品型号
          is_remove: this.formItem.is_remove, // 拆卸要求 0-不用到这个,1-需要拆卸,2-不需要拆卸
          product_size: this.formItem.product_size || '', // 商品尺寸
          product_maintain: this.formItem.maintain || '', //保养要求
          product_maintain_id: this.formItem.maintain_id + '' || '', //保养要求id
          special: this.formItem.special || '', // 特殊要求
          product_price: this.formItem.product_price || 0
        }
        if(this.order_id){
          data.order_no=this.order_id+''
        }
        this.$util.throttle(() => {
          this.$request('611c676dd8aab', data).then(res => {
            vm.step = 2
            // 回到顶部
            document.documentElement.scrollTop = 0
          })
        }, 2000, true)

      },
      placeOrder() {
        let vm = this
        vm.step = 1
        vm.order_munber = ""
        vm.recommend_price = 0
        vm.formItem = {
          product_img: [],
          environment_img: [],
          class_id: 0,
          product_first_class_id: 0,
          number: 1,
          product_class_id: 0,
          total_price: 0,
          product_model: '',
          special: '',
          arrive: '2',
          behalf: '2',
          is_remove: '2',
          elevator: '2',
          install_upload: '1',
          order_type: 1,
          type_id: 1,
          maintain_id: '',
          maintain: ''
        }
        vm.formTwo = {
          name: "",
          phone: "",
          address: "",
          floor: 0,
          is_elevator: 1,
          number: 0,
          price: 0,
        }
        vm.fromThree = {
          order_contact: "",
          order_phone: "",
          hope_complete: "",
          third_name: "0",
          is_logistics: 1,
          name: "",
          is_arrive: 0,
          phone: "",
          company: 0,
          address: "",
          package_require: 0,
          package_number: 0,
          valuation: "0",
          is_freight: 1,
          freight: 0,
          shipping_method: 0,
          pay_method: 0,
          arrive_time: "",
          logistics_number: "",
        }
      },
      async submit() {
        let vm = this
        if (!this.formTwo.name) {
          return this.$message.error('请输入真实姓名')
        }
        if (!this.formTwo.phone) {
          return this.$message.error('请输入电话')
        }
        if (!/^1[3-9]\d{9}$/.test(this.formTwo.phone)) {
          return this.$message.error('请输入正确的电话')
        }
        if (!this.formTwo.city) {
          return this.$message.error('请选择位置')
        }
        if (!this.formTwo.address) {
          return this.$message.error('请输入详细地址')
        }
        if (!this.fromThree.order_contact) {
          return this.$message.error('请输入订单联系人')
        }
        if (!this.fromThree.order_phone) {
          return this.$message.error('请输入订单联系电话')
        }
        if (!/^1[3-9]\d{9}$/.test(this.fromThree.order_phone)) {
          return this.$message.error('请输入正确的订单联系电话')
        }
        await this.getGeo(this.formTwo.city, this.formTwo.address);
        this.$util.throttle(() => {
          this.$request('611cbabeb8a86', {
            name: vm.formTwo.name,
            phone: vm.formTwo.phone,
            pro_city_dist: vm.formTwo.city, //省市区
            detailed_address: vm.formTwo.address, //详细地址
            address: vm.formTwo.city + '-' + vm.formTwo.address,
            floor: vm.formTwo.floor.toString(),
            is_elevator: vm.formTwo.is_elevator==''?'0':vm.formTwo.is_elevator,
            number: vm.formTwo.number,
            price: vm.formTwo.price,
            latitude: vm.formTwo.latitude,
            longitude: vm.formTwo.longitude,
            order_no:vm.order_id||''
          }).then(restwo => {
            let data1={
              order_contact: vm.fromThree.order_contact,
              order_phone: vm.fromThree.order_phone,
              hope_complete: vm.fromThree.hope_complete,
              third_name: vm.fromThree.third_name,
              is_logistics: vm.fromThree.is_logistics,
              name: vm.fromThree.name,
              is_arrive: vm.fromThree.is_arrive,
              phone: vm.fromThree.phone,
              company: vm.fromThree.company,
              address: vm.fromThree.address,
              package_require: vm.fromThree.package_require,
              package_number: vm.fromThree.package_number,
              valuation: vm.fromThree.valuation + '',
              is_freight: vm.fromThree.is_freight,
              freight: vm.fromThree.freight.toString(),
              shipping_method: vm.fromThree.shipping_method,
              pay_method: vm.fromThree.pay_method,
              arrive_time: vm.fromThree.arrive_time+'',
              logistics_number: vm.fromThree.logistics_number.split(','),
            }
            if(vm.order_id>0){
              data1.order_no=vm.order_id+''
            }
            this.$request('611cdc0bc0a13',data1).then(res => {
              vm.order_munber = res.data.data.order_munber
              vm.step = 3
              vm.allAddress = ''
              console.log(res)
            })
          })
        }, 2000, true)
      },
      cityChange(e, a) {
        let list = a.map(item => {
          return item.label;
        })
        console.log(e, a, '选择省市区');
        this.formTwo.city = list.join('-');
      },
      getGeo(city, addr) {
        return new Promise(resolve => {
          this.$request('63ddc6e83d13b', {
            address: addr,
            city: city
          }).then(res => {
            let location = res.data.data[0].location.split(',');
            this.formTwo.longitude = location[0];
            this.formTwo.latitude = location[1];
            let code = res.data.data[0].adcode;
            let province = code.substr(0, 2) + '0000';
            let city = code.substr(0, 4) + '00';
            this.city = [province, city, code];
            console.log(this.city, 'this.city');
            resolve();
          })
        })
        return;
        return new Promise(resolve => {
          this.$request(
            `https://restapi.amap.com/v3/geocode/geo?key=e593625362ebbe9519261f4e4b2fcbbd&address=${addr}&city=${city}`, {},
            'get').then(res => {
            let location = res.data.geocodes[0].location.split(',')
            let code = res.data.geocodes[0].adcode;
            let province = code.substr(0, 2) + '0000';
            let city = code.substr(0, 4) + '00';
            this.city = [province, city, code];
            this.formTwo.city = res.data.geocodes[0].province + '-' + res.data.geocodes[0]
              .city + '-' + res.data.geocodes[0].district
            resolve(location);
          })
        })
      },
      // 选择附属商品
      selectAccessory(e) {
        let vm = this
        let idx = vm.accessoryGoods.findIndex(item => item.id == e)
        vm.formItem.accessory = vm.accessoryGoods[idx].name
        vm.formItem.accessory_id = vm.accessoryGoods[idx].id
      },
      selectMaintain(e) {
        let vm = this
        let idx = vm.maintainList.findIndex(item => item.id == e)
        console.log(idx, 'idx保养');
        vm.formItem.maintain_id = e
        vm.formItem.maintain = vm.maintainList[idx].value
      },
      // 选择一级
      selectChange(e) {
        let vm = this
        vm.classTwo = []
        vm.formItem.product_class_id = 0
        let idx = vm.allClass.findIndex(item => item.id == e)
        vm.product_first_class_id = vm.allClass[idx].id
        vm.classTwo = vm.allClass[idx].childens
        vm.formItem.recommend_price = vm.allClass[idx].recommend_price || 0
        vm.formItem.product_price = vm.allClass[idx].recommend_price || 0
        vm.recommend_price = vm.allClass[idx].recommend_price || 0
        vm.calculationTotal()



      },
      // 选择二级
      selectChangeTwo(e) {
        let vm = this
        let idx = vm.classTwo.findIndex(item => item.id == e)
        vm.formItem.product_class_id = vm.classTwo[idx].id
        vm.formItem.recommend_price = vm.classTwo[idx].recommend_price || 0
        vm.formItem.product_price = vm.classTwo[idx].recommend_price || 0
        vm.recommend_price = vm.classTwo[idx].recommend_price || 0
        vm.calculationTotal()
        // 附属商品
        vm.getAccessoryList()
      },
      numberChange(value) {
        let vm = this

        vm.formItem.number = value

        vm.calculationTotal()
      },
      calculationTotal() {
        let vm = this
        vm.formItem.total_price = vm.recommend_price * vm.formItem.number
      },

    }
  }
</script>

<style lang="less">
  .place {

    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      min-width: 1200px;
      padding: 0 100px;
      background-color: #f7f8fa;
      margin-top: 84px;

      .step {
        display: flex;
        align-items: center;
        height: 60px;
        background-color: #FFFFFF;
        padding: 0 20px;
      }

      .title {
        font-size: 18px;
        color: #333;
        font-weight: 450;
        margin-top: 20px;
      }

      .category {
        margin-top: 20px;

        .category-list {
          padding: 30px;
          background-color: #FFFFFF;
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;

          .category-item {
            width: 145px;
            padding: 30px 0;
            border-radius: 3px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .name {
              margin-top: 10px;
            }

          }

          .active {
            background-color: #FB9E2F;
            color: #FFFFFF;
          }
        }
      }

      .mode-view {
        padding: 30px;
        background-color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .form {
        padding: 30px;
        background-color: #FFFFFF;
        margin-top: 10px;

        .unit {
          margin-left: 10px;
          display: inline-block;
        }

        .price {
          display: inline-block;
          color: red;
          margin-left: 30px;
        }

        .input {
          width: 500px;
        }

        .tips {
          color: #666666;
          font-size: 12px;
        }

        .footer {
          margin-top: 30px;
          margin-bottom: 20px;
        }
      }
    }

    .ivu-input-number-controls-outside-btn {
      height: 38px;
      line-height: 38px;
    }

    .footer {
      position: fixed;
      width: 100%;
      z-index: 9;
      bottom: 0;
      height: 60px;
      padding: 0 100px;
      background-color: #FFFFFF;
      border-top: 1px solid #f7f8fa;

      .place {
        height: 100%;
        display: flex;
        align-items: center;
        //justify-content: flex-end;
      }

      .other {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .box-content-map {
      position: fixed;
      left: 0;
      right: 0;
      width: 45%;
      top: 10%;
      height: 83vh;
      z-index: 1510;
      margin: auto;
    }
  }
</style>